// extracted by mini-css-extract-plugin
module.exports = {"background":"progressBar_background__2Tudi","foreground":"progressBar_foreground__2zczx","label":"progressBar_label__2SvXp"};